import { storyblokDataAttributes } from "@commerce-frontend/storyblok-preview/component";
import { graphql } from "@commerce-frontend/types";
import type { ResultOf } from "@graphql-typed-document-node/core";
import type { HTMLAttributes } from "react";

export const IframeFragment = graphql(/* GraphQL */ `
	fragment IframeFragment on Iframe {
		__typename
		id
		url
		height
	}
`);

type IframeBlockProps = {
	data: ResultOf<typeof IframeFragment>;
} & HTMLAttributes<HTMLDivElement>;

export const Iframe = ({ className, data }: IframeBlockProps) => {
	const { id, url, height } = data;

	if (!url.length) return;

	return (
		<div className={className} {...storyblokDataAttributes(data)}>
			<iframe title={id} className="w-full" src={url} height={height ?? "100%"} />
		</div>
	);
};
